import { featureTogglesStore } from "csi/state/rootStore";
import New from "csi/table/New";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const NewCareAndComposition = declare(New, {
	/*
	* @override
	* Adds Conditional Logic to add subtype based on Feature Flag
	*/
	toWriter() {
		this.inherited(arguments);
		const compositionFeatureFlagEnabled = featureTogglesStore.CAREANDCOMPOSITION_DATASHEET_USE_REACT_UI;
		if (!compositionFeatureFlagEnabled) {
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("Subtype", xml.ATTR_REF, "centric://REFLECTION/INSTANCE/CareAndCompositionSubtype/CareAndComposition");
		}
	},
});

export = NewCareAndComposition;